import { render, staticRenderFns } from "./error.vue?vue&type=template&id=d6c5042e"
import script from "./error.vue?vue&type=script&setup=true&lang=ts"
export * from "./error.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports